import React, { Component } from 'react'
import { connect } from 'react-redux'
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { Grid } from '@material-ui/core';
import {Link} from 'react-router-dom'
import Button from '@material-ui/core/Button';

class AreaForm extends Component{
    constructor(props) {
        super(props)
        this.state = {
            areaNameTm             : this.props.Name_tn && this.props.Name_tn != "null" ? this.props.Name_tn : "",
            areaName               : this.props.Name    ? this.props.Name    : "",
            areaNameErr            : '',
            areaNameTmErr          : '' ,
            id                     : this.props.Id 
        }
    }

    componentDidMount(){
    }

    handleSubmit = (e) =>{
        e.preventDefault()
        const err = this.checkValidity()
        if(!err){
            const props=this.props
            const formdata={
                token      : this.props.token,
                name       : this.state.areaName,
                name_tn    : this.state.areaNameTm,
                id         : this.state.id
            }
            this.props.handleSubmit(formdata,props)
        }
    }
    handleChange = (e) => {
        this.setState({[e.target.name] : e.target.value}, ()=>{
            this.checkValidity()
        })   
    }
    
    checkValidity = () => {
        let isError = false
        if(!this.state.areaName){
            isError=true
            this.setState({areaNameErr:'*This field is required'})
        }
        // if(!this.state.zoneNameTm){
        //     isError=true
        //     this.setState({zoneNameTmErr : "*This field is required"})
        // }
        return isError
    }

    render(){
        return (
            <div>
                <div className="create_ulb_content_outer">
                    <div className="create_ulb_content">
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                        <FormControl>
                            <label className="required" htmlFor="areaName">Area Name</label>
                            <TextField id="areaName" 
                                    variant="outlined" 
                                    placeholder="Enter Area Name" 
                                    name="areaName" 
                                    value={this.state.areaName} 
                                    onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.usernameErr}</div>
                        </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                        <FormControl>
                            <label htmlFor="areaNameTm">Area Name(Tamil)</label>
                            <TextField id="areaNameTm" 
                                variant="outlined" 
                                placeholder="மண்டல பெயரை உள்ளிடவும்" 
                                name="areaNameTm" 
                                value={this.state.areaNameTm} 
                                onChange={this.handleChange}/>
                            <div style={{fontSize:12,color:"red", fontFamily:"'Open Sans', sans-serif", marginTop:"1%"}}>{this.state.emailErr}</div>
                        </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <div className="create_ulb_buttons">
                            <Link style={{textDecoration:"none", color:"#3dab35"}} to="/area-management"><Button className="login_submit" variant="outlined" color="primary">Cancel</Button></Link>
                            <Button className="login_submit" variant="contained" color="primary" onClick ={this.handleSubmit}>Save</Button>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
        )
    }    
}

const mapStateToProps = (state) => ({
    token : state.auth.token
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(AreaForm)